import { Box, Chip } from '@mui/material';
import type {
  AverageMargin,
  MarginSummaryCategory,
} from 'api/managementReportApi';
import { blue } from '@mui/material/colors';
import React from 'react';
import { getMarginSummaryCategoryLabel } from './marginSummaryLabels';

export type MarginSummaryCategoryChipsProps = {
  summaries: AverageMargin[];
  selectedCategory: MarginSummaryCategory | '';
  onSelect: (category: MarginSummaryCategory) => void;
};

const MarginSummaryCategoryChips = ({
  summaries,
  selectedCategory,
  onSelect,
}: MarginSummaryCategoryChipsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        mb: 2,
        overflowX: 'auto',
        pb: 0.5,
      }}>
      {summaries.map((categorySummary) => (
        <Box
          key={`chip-${categorySummary.category}`}
          sx={{ display: 'inline-grid', justifyContent: 'center', mr: 1 }}>
          <Chip
            clickable
            label={`${getMarginSummaryCategoryLabel(
              categorySummary.category
            )} Summary`}
            style={{
              backgroundColor:
                selectedCategory === categorySummary.category
                  ? blue[900]
                  : 'lightgrey',
            }} // use style prop to override default colors (sx doesn't work well with bgColor in this case)
            sx={{
              fontWeight: 'bold',
              color:
                selectedCategory === categorySummary.category
                  ? 'white'
                  : 'black',
              border: 'none',
            }}
            onClick={() => {
              onSelect(categorySummary.category);
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default MarginSummaryCategoryChips;
